import { useAuth } from '@contexts/User.context';
import { ENTITLEMENTS } from '@utils/entitlements';

/**
 * Whether the current user may see admin billing links. This is the single
 * place for the gate: billing lives in the platform admin panel, so it is
 * platform administrators only (`admin.all`), never organization admins.
 */
const useCanViewBilling = () => useAuth().can(ENTITLEMENTS.ADMIN_ALL);

export default useCanViewBilling;
